import Terms from './term';
import { Grid, Toolbar, Box } from '@mui/material';
import PropTypes from 'prop-types';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Zoom from '@mui/material/Zoom';
import Fab from '@mui/material/Fab';
import Background from '../../components/LayoutComponents/Background'

function ScrollTop(props) {
    const { children } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 100
    });

    const handleClick = (event) => {
        const anchor = (event.target.ownerDocument || document).querySelector(
            "#back-to-top-anchor"
        );

        if (anchor) {
            anchor.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    return (
        <Zoom in={trigger}>
            <Box
                onClick={handleClick}
                role="presentation"
                sx={{
                    position: "fixed",
                    bottom: '2em',
                    right: '2em'
                }}
            >
                {children}
            </Box>
        </Zoom>
    );
};

ScrollTop.propTypes = {
    children: PropTypes.element.isRequired
};

const Compliance = () => {
    return (
        <Background>
            <Toolbar id="back-to-top-anchor" />
            <br />
            <Grid container alignItems="center" justifyContent="center" width={"80%"}>
                <Grid item >
                    <Terms />
                </Grid>
            </Grid>
            <ScrollTop>
                <Fab color="secondary" size="small" aria-label="scroll back to top">
                    <KeyboardArrowUpIcon />
                </Fab>
            </ScrollTop>
        </Background>
    );
};

export default Compliance;
